unable to read source [project]/node_modules/stripe/src/stripe.esm.node.ts